<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    :aria-hidden="!$attrs['aria-label']"
  >
    <path
      d="M5.30773 20.5C4.8026 20.5 4.37503 20.325 4.02503 19.975C3.67503 19.625 3.50003 19.1974 3.50003 18.6923V5.30773C3.50003 4.8026 3.67503 4.37503 4.02503 4.02503C4.37503 3.67503 4.8026 3.50003 5.30773 3.50003H12.0096V5.00001H5.30773C5.2308 5.00001 5.16027 5.03206 5.09616 5.09616C5.03206 5.16027 5.00001 5.2308 5.00001 5.30773V18.6923C5.00001 18.7692 5.03206 18.8397 5.09616 18.9039C5.16027 18.968 5.2308 19 5.30773 19H12.0096V20.5H5.30773ZM16.2308 16.2692L15.1924 15.1846L17.627 12.75H9.09616V11.25H17.627L15.1924 8.81541L16.2308 7.73083L20.5 12L16.2308 16.2692Z"
      fill="currentColor"
    />
  </svg>
</template>
